import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap/scss/bootstrap.scss'
import './assets/scss/app.scss'
createApp(App).mount('#app')
